import BaseModelRequest from "./base/BaseModelRequest";

export default class BalanceRequest extends BaseModelRequest {
  getBalanceTransactionMain(currency) {
    return this.get(`/balance-transaction-main/${currency}`);
  }
}
